import api from './client'
import type { Club, ClubDetail, ClubEventType, ClubPage } from '../types'

export interface ClubListItem extends Club {
  memberCount: number
}

export interface ClubEventInput {
  type: ClubEventType
  title: string
  date: string
  time?: string
  endDate?: string
  location?: string
  description?: string
}

export async function listClubs(): Promise<ClubListItem[]> {
  const { data } = await api.get('/clubs')
  return data.clubs
}

export async function getClub(slug: string): Promise<ClubDetail> {
  const { data } = await api.get(`/clubs/${slug}`)
  return data
}

export async function saveClubPage(
  clubNum: number,
  page: Partial<Omit<ClubPage, 'clubNum' | 'slug' | 'lastUpdated' | 'updatedBy'>>,
): Promise<{ success: boolean; lastUpdated: string }> {
  const { data } = await api.put(`/clubs/${clubNum}/page`, page)
  return data
}

export async function uploadClubImage(
  clubNum: number,
  file: File,
): Promise<{ success: boolean; photoUrl: string }> {
  const formData = new FormData()
  formData.append('image', file)
  const { data } = await api.post(`/clubs/${clubNum}/page/image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}

export async function createClubEvent(
  clubNum: number,
  input: ClubEventInput,
): Promise<{ success: boolean; id: number }> {
  const { data } = await api.post(`/clubs/${clubNum}/events`, input)
  return data
}

export async function updateClubEvent(
  clubNum: number,
  eventId: number,
  input: ClubEventInput,
): Promise<{ success: boolean }> {
  const { data } = await api.put(`/clubs/${clubNum}/events/${eventId}`, input)
  return data
}

export async function deleteClubEvent(
  clubNum: number,
  eventId: number,
): Promise<{ success: boolean }> {
  const { data } = await api.delete(`/clubs/${clubNum}/events/${eventId}`)
  return data
}
